"use client"

import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"

export function ToolWorkingHoursSetting({ checked, onCheckedChange, disabled = false, id }: {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  id: string
}) {
  return (
    <div className="flex items-center gap-3 rounded-md border p-3">
      <Checkbox id={id} checked={checked} disabled={disabled}
        onCheckedChange={value => onCheckedChange(value === true)} />
      <div className="space-y-1">
        <Label htmlFor={id}>Keep this task inside organization working hours</Label>
        <p className="text-xs text-muted-foreground">
          When enabled, tasks requested outside the organization&apos;s weekday hours move to the next available time.
        </p>
      </div>
    </div>
  )
}
